import * as constants from "./constants"

export const fetchRemoteConfigurationRequest = () => ({
  type: constants.FETCH_REMOTE_CONFIGURATION_REQUEST,
});

export const  fetchRemoteConfigurationSuccess = (data) => ({
  type: constants.FETCH_REMOTE_CONFIGURATION_SUCCESS,
  data,
});

export const fetchRemoteConfigurationFail = (error) => ({
  type: constants.FETCH_REMOTE_CONFIGURATION_FAIL,
  error,
});
